export enum OwnershipForm {
  Ownership = 1,
  PerpetualUsufruct,
}
